import { ZodError } from 'zod';
import { EnvConfig, envSchema } from './env.schema';

const validateEnv = (env: Record<string, unknown>): EnvConfig => {
  try {
    return envSchema.parse(env);
  } catch (error) {
    if (error instanceof ZodError) {
      throw new Error(
        `Config validation errors: ${error.errors
          .map((error) => JSON.stringify(error, null, 0))
          .join(', \n')}`,
      );
    }
    throw error;
  }
};

export const getEnv = <T = string>(key: keyof EnvConfig): T => {
  try {
    return envSchema.parse(key, { [key]: import.meta.env[key] }) as T;
  } catch (error) {
    if (error instanceof ZodError) {
      throw new Error(`Config validation errors: ${error.errors.join(', \n')}`);
    }
    throw error;
  }
};

export const createEnv = (): EnvConfig => {
  return validateEnv(import.meta.env);
};
